
export default (urlParameters) => {
  return {
    favorites_button: true,
    detail_panel: true,
    map_favoriting: true,
    map_name_block: true,
    map_selector_button: true,
    pinned_map_bar: true,
    points_of_interest: true
  }
}